
<template>
  <div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8158 2.25465C16.5749 1.96758 16.1781 1.92033 15.8867 2.12763L15.8027 2.19747L6.23748 11.4282C5.94723 11.7083 5.92304 12.179 6.16492 12.4909L6.23748 12.5718L15.8027 21.8025C16.0972 22.0867 16.5508 22.0611 16.8158 21.7454C17.0568 21.4583 17.059 21.0302 16.8361 20.7412L16.7625 20.659L7.78965 12L16.7625 3.341C17.0302 3.08264 17.0743 2.65719 16.881 2.34472L16.8158 2.25465Z" fill="black"/>
    </svg>
  </div>
</template>
    
<script>
export default {
  components: {
  },
  props: {
    isHovered: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
svg {
  height: 25px;
}  
</style>
  
    